import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import useAuth from '../hooks/useAuth';

export default function PrivateRoute({ roles, children }) {
  const { user, isAuthenticated, loading, sessionExpired } = useAuth();
  const location = useLocation();

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location, sessionExpired }} replace />;
  }

  if (roles && !roles.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }

  // Si se usa como wrapper con children (para rutas específicas)
  if (children) return children;

  // Si se usa como layout route
  return <Outlet />;
}
